import type { Task } from '@ztechapps/common.contract'
import { useUser } from '@ztechapps/common.hook'
import { taskDocumentQueries } from '@ztechapps/task.common'
import { useAddProjectTasks } from '@ztechapps/project.common'

type UseQuickAddTaskProps = {
  onSuccess?: () => void
}

export type QuickAddTaskFormValues = {
  name: string
  project: { _id: string } | null
  status?: string
}

export const useQuickAddTask = ({ onSuccess }: UseQuickAddTaskProps = {}) => {
  const { user } = useUser()
  const [onAddProjectTasks, { error, loading }] = useAddProjectTasks({
    query: undefined,
    options: {
      mutationOptions: {
        refetchQueries: [...taskDocumentQueries.createConfig.refetchQueries, 'allProject', 'singleProject'],
        awaitRefetchQueries: true,
      },
    },
  })

  const onSubmit = async ({ name, project, status }: QuickAddTaskFormValues): Promise<void> => {
    const taskInput = {
      name,
      ...(status ? { status } : {}),
      members: [{ _id: user?._id }],
    } as Task

    await onAddProjectTasks({ project: { _id: project?._id }, tasks: [taskInput] } as any)
    onSuccess?.()
  }

  return { onSubmit, error, loading }
}
